import React from "react";
import { Link } from "react-router-dom";

const Error = () => {
	return (
		<div className="w-full h-[70vh] p-6">
			<div className="h-full flex flex-col gap-4 items-center justify-center shadow-lg shadow-orange-600 text-orange-600">
				<h1 className="text-2xl font-bold">Something went Wrong.</h1>
				<p className="text-xl font-semibold">Please try again later.</p>
				<Link
					className="border-2 border-orange-600 px-4 py-1 rounded-md hover:text-white hover:bg-orange-600"
					to="/"
				>
					Back
				</Link>
			</div>
		</div>
	);
};

export default Error;
